export default __webpack_public_path__ + "static/media/Discord.9f9a0406.png";